var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonAddOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13 8.78947 11.7895 10 10 10C8.21053 10 7 8.78947 7 7C7 5.21053 8.21053 4 10 4C11.7895 4 13 5.21053 13 7ZM15 7C15 4.22807 12.7719 2 10 2C7.22807 2 5 4.22807 5 7C5 9.77193 7.22807 12 10 12C12.7719 12 15 9.77193 15 7ZM10 15C14.193 15 17 16.4035 17 18C17 19.2281 16.2281 20 15 20H5C3.77193 20 3 19.2281 3 18C3 16.4035 5.80702 15 10 15ZM10 13C5.17544 13 1 15.0175 1 18C1 20.2105 2.78947 22 5 22H15C17.2105 22 19 20.2105 19 18C19 15.0175 14.8246 13 10 13ZM18 8V14C18 14.5439 18.4561 15 19 15C19.5439 15 20 14.5439 20 14V8C20 7.45614 19.5439 7 19 7C18.4561 7 18 7.45614 18 8ZM16 12H22C22.5439 12 23 11.5439 23 11C23 10.4561 22.5439 10 22 10H16C15.4561 10 15 10.4561 15 11C15 11.5439 15.4561 12 16 12Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddOutlined);
export default __webpack_public_path__ + "static/media/person_add_outlined.c21c54a0.svg";
export { ForwardRef as ReactComponent };